import { AddImportScheduleError, ImportStatusCode } from '@bechtel/types';
import { ApolloError } from '@apollo/client';

export type ImportScheduleErrorExt = AddImportScheduleError | ApolloError;
export type ImportStatusCodeExt = ImportStatusCode | InitialImportStatus;
export interface ImportScheduleErrorProps {
  error: ImportScheduleErrorExt;
  close: () => void;
}
export interface ImportStatusStyledProps {
  status: ImportStatusCodeExt;
}
export enum InitialImportStatus {
  NOT_STARTED = 'NOT_STARTED',
}
